import { BASE_URL } from '@lib/constants';
import { setMany } from 'idb-keyval';

const initState = {
	activeSections: {},
	inActiveSections: {},
	sections: {},
	newActiveIds: [],
	sharedSections: {},
	sharedActive: {},
	binIsActive: false,
};

const removalUpdateCount = `${BASE_URL}/wp-json/edu_api/reporting/content/removal/update`;

const courseReducer = (state = initState, action) => {
	switch (action.type) {
		case 'SET_BIN_ACTIVE': {
			return {
				...state,
				binIsActive: action.payload.binIsActive,
			};
		}

		case 'DELETE_CARD_DATA': {
			const { trash, bucket, post, index } = action.payload;

			// Determine mode
			const isShared = state.sharedActive && Object.keys(state.sharedActive).length > 0;

			// Clone active and inactive data safely
			const active = isShared ? { ...state.sharedActive } : { ...state.activeSections };
			const inActive = { ...state.inActiveSections };

			// Defensive: ensure bucket exists
			if (!active[bucket] && !inActive[bucket]) return state;

			if (trash) {
				// Removing from active
				if (active[bucket]) {
					active[bucket] = {
						...active[bucket],
						articles: [
							...active[bucket].articles.slice(0, index),
							...active[bucket].articles.slice(index + 1),
						],
					};
				}
			} else {
				// Removing from inActive
				if (inActive[bucket]) {
					inActive[bucket] = {
						...inActive[bucket],
						articles: [
							...inActive[bucket].articles.slice(0, index),
							...inActive[bucket].articles.slice(index + 1),
						],
					};
				}
			}

			// Save correct keys based on mode
			const savePayload = isShared
				? [
						['activeSections', active],
						['inActiveSections', inActive],
					]
				: [
						['activeSections', active],
						['inActiveSections', inActive],
					];

			setMany(savePayload);

			return {
				...state,
				activeSections: isShared ? state.activeSections : active,
				sharedActive: isShared ? active : state.sharedActive,
				inActiveSections: inActive,
			};
		}
		case 'SET_CARD_STATUS': {
			const { trash, bucket, post, index } = action.payload;

			const isShared = state.sharedActive && Object.keys(state.sharedActive).length > 0;

			const active = isShared ? { ...state.sharedActive } : { ...state.activeSections };
			const inActive = { ...state.inActiveSections };

			// Ensure the buckets exist
			if (!active[bucket]) active[bucket] = { ...state.sections[bucket], articles: [] };
			if (!inActive[bucket]) inActive[bucket] = { ...state.sections[bucket], articles: [] };

			// Clone the arrays to avoid mutations
			const activeArticles = [...(active[bucket].articles || [])];
			const inActiveArticles = [...(inActive[bucket].articles || [])];

			if (trash) {
				// Moving from active → inActive (trash)
				const [removed] = activeArticles.splice(index, 1);
				if (removed) {
					inActiveArticles.push(removed); // or post, if same
				}

				if (post?.id) {
					fetch(`${removalUpdateCount}?content_id=${post.id}`, {
						method: 'GET',
						headers: { 'Content-Type': 'application/json' },
					}).catch((err) => console.error('Error logging removal', err));
				}
			} else {
				// Moving from inActive → active (restore)
				const itemIndex = inActiveArticles.findIndex((item) => item.id === post.id);
				let removed = null;

				if (itemIndex !== -1) {
					[removed] = inActiveArticles.splice(itemIndex, 1);
				}

				if (removed) {
					//activeArticles.push(removed); // or post

					// First: remove any existing duplicate in active
					const existingIndex = activeArticles.findIndex((item) => item.id === removed.id);
					if (existingIndex !== -1) {
						activeArticles.splice(existingIndex, 1);
					}

					// Then add the restored article
					activeArticles.push(removed);
				}
			}

			// Update sections
			active[bucket] = {
				...active[bucket],
				articles: activeArticles,
			};

			inActive[bucket] = {
				...inActive[bucket],
				articles: inActiveArticles,
			};

			const savePayload = isShared
				? [
						['activeSections', active],
						['sharedActive', active],
						['inActiveSections', inActive],
					]
				: [
						['sharedActive', active],
						['activeSections', active],
						['inActiveSections', inActive],
					];

			setMany(savePayload);

			return {
				...state,
				activeSections: isShared ? state.activeSections : active,
				sharedActive: isShared ? active : state.sharedActive,
				inActiveSections: inActive,
			};
		}
		case 'LOAD_PROSPECTUS': {
			setMany([
				['sections', action.payload.sections],
				['activeSections', action.payload.activeSections],
				['inActiveSections', action.payload.inActiveSections],
			]);

			return {
				...state,
				sections: action.payload.sections,
				activeSections: action.payload.activeSections,
				inActiveSections: action.payload.inActiveSections,
			};
		}
		case 'SET_SHARE_DATA': {
			return {
				...state,
				sharedSections: action.payload.sections,
				sharedActive: action.payload.active,
				prospectusId: action.payload.prospectusId || null,
				inActiveSections: action.payload.inActiveSections || {},
				prospectData: action.payload.prospectData || {},
				prospectusOverviewTitle: action.payload.prospectusOverviewTitle || '',
				prospectusOverviewDesc: action.payload.prospectusOverviewDesc || {},
				selectedWayfinderAnswers: action.payload.selectedWayfinderAnswers || {},
			};
		}
		case 'SET_SECTIONS': {
			const returnData = {
				...state,
			};

			if (action.payload.sections) {
				returnData.sections = action.payload.sections;
			}

			if (action.payload.activeSections) {
				returnData.activeSections = action.payload.activeSections;
			}

			if (action.payload.inActiveSections) {
				returnData.inActiveSections = action.payload.inActiveSections;
			}

			if (action.payload.newActiveIds) {
				returnData.newActiveIds = action.payload.newActiveIds;
			}

			return returnData;
		}
		default: {
			return { ...state };
		}
	}
};

export default courseReducer;
